<template>
    <div class="col-md-12">
        <br />
        <form @submit.prevent="searchData()" role="form">
            <div class="row">
                <div class="col-2">

                    <input type="text"
                           class="form-control "
                           v-model="pagingInfo.search"
                           placeholder="Search..." />

                </div>
                <div class="col-2">

                    <select id="region"
                            class="form-control "
                            v-model="pagingInfo.mydata">
                        <option value="0">All Data</option>
                        <option value="1">My Encodes</option>
                    </select>

                </div>
                <div class="col-2">

                    <button type="submit" class="btn btn-info ">
                        <strong>Search</strong>
                    </button>&nbsp;
                    <button type="button" v-on:click="clearControls()" class="btn btn-primary">Clear</button>

                </div>
            </div>
        </form>
        <br />
        <div class="box">
            <div class="box-header"></div>
            <div class="box-body table-responsive no-padding">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>
                                <a @click="sort('Type')">Type</a>
                            </th>
                            <th>
                                <a @click="sort('Subject')">Subject</a>
                            </th>
                            <th>Comments</th>
                            <th>Created By</th>
                            <th>
                                <a @click="sort('DateCreated')">Date Created</a>
                            </th>
                            <th>Updated By</th>
                            <th>
                                <a @click="sort('DateUpdated')">Date Updated</a>
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(user, index) in events" :key="user.id">
                            <td>{{ user.type }}</td>
                            <td>{{ user.title | capitalize }}</td>
                            <td>{{ user.comments | capitalize }}</td>
                            <td>{{ user.createdBy }}</td>
                            <td>{{ user.dateCreated | formatDate }}</td>
                            <td>{{ user.updatedBy }}</td>
                            <td>{{ user.dateUpdated | formatDate }}</td>
                            <td v-if="$store.getters.LINKMODE">
                                <button class="btn btn-sm btn-success"
                                        @click="setLink(user.id)">
                                    Link Object
                                </button>
                            </td>

                            <td v-else-if="$store.getters.CRAD">
                                <TheDropDownButton>
                                    <btn @click.native="deleteEvent(user.id, index)"
                                         icon="fa fa-trash"
                                         title="Delete"></btn>
                                    <btn @click.native="editEvent(user.id)"
                                         icon="fa fa-pencil-alt"
                                         title="Edit"></btn>
                                    <btn @click.native="addtoMerge(user)"
                                         icon="fa fa-code-branch"
                                         title="Merge Record"></btn>
                                    <btn @click.native="requestlinkdownload(user.id)"
                                         icon="fa fa-cloud-download-alt"
                                         title="Export"></btn>
                                    <btn @click.native="More(user)"
                                         icon="fa fa-expand-alt"
                                         title="View Linkages"></btn>
                                    <btn @click.native="startLink(user)"
                                         icon="fa fa-compress"
                                         title="Enable Link Mode"></btn>
                                </TheDropDownButton>
                            </td>
                            <td v-else-if="$store.getters.VIEWER">
                                <TheDropDownButton>
                                    <btn @click.native="More(user)"
                                         icon="fa fa-expand-alt"
                                         title="View Linkages"></btn>
                                </TheDropDownButton>
                            </td>
                            <td v-else>
                                <TheDropDownButton>
                                    <btn v-if="mydata"
                                         @click.native="editEvent(user.id)"
                                         icon="fa fa-pencil-alt"
                                         title="Edit"></btn>
                                    <btn @click.native="More(user)"
                                         icon="fa fa-expand-alt"
                                         title="View Linkages"></btn>
                                    <btn @click.native="startLink(user)"
                                         icon="fa fa-compress"
                                         title="Enable Link Mode"></btn>
                                </TheDropDownButton>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot></tfoot>
                </table>

                <div v-show="totalitems == 0" class="alert alert-warning">
                    <p>Found no result try again</p>
                </div>
            </div>
        </div>

        <b-pagination v-model="pagingInfo.page"
                      v-on:input="fetchData()"
                      :total-rows="totalitems"
                      :per-page="pagingInfo.itemsPerPage"
                      first-text="First"
                      prev-text="Prev"
                      next-text="Next"
                      last-text="Last"></b-pagination>
        <b-modal id="LinkPopupEV" title="Link Builder" scrollable hide-footer>
            <LinkPopUp />
        </b-modal>
        <b-modal id="EditPopUPEV"
                 title="Edit Event"
                 size="lg"
                 scrollable
                 hide-footer>
            <EventEdit v-bind:id="eventId" v-on:done-edit-event="doneEdit()" />
        </b-modal>

        <b-modal id="linkpopupev" size="xl" scrollable hide-footer>
            <LinkComponentPopEV v-bind:id="linkid"
                                v-bind:linkdescription="linkdescription" />
        </b-modal>
        <b-modal id="mergerecordev"
                 size="md"
                 hide-footer
                 ref="merger"
                 no-close-on-esc="true"
                 no-close-on-backdrop="true"
                 hide-header-close="true">
            <MergePopUpev v-bind:obj1ID="obj1Id"
                          v-bind:obj2ID="obj2Id"
                          v-bind:obj1Desc="obj1description"
                          v-bind:obj2Desc="obj2description"
                          v-bind:objType="objType"
                          v-on:done="done()"
                          v-on:cancel="cancel()" />
        </b-modal>
    </div>
</template>

<script>
    import {
        authHeader,
        responseCheck,
        RecordURL,
        setObject2Link,
        RequestLink,
        notifyHelper,
    } from "../helper";
    import LinkPopUp from "./master/Linking";
    import EventEdit from "./edit/Event";
    import btn from "./buttons/iconButton";
    import LinkComponentPopEV from "./link/linkcomponent";
    import MergePopUpev from "./master/recordMerge";
    import instance from "../helper/http";
    export default {
        data() {
            return {
                events: [],
                pagingInfo: {
                    page: 1,
                    sortBy: "Type",
                    reverse: false,
                    search: "",
                    mydata: 0,
                },
                totalitems: null,
                eventId: "",
                mydata: false,
                linkid: "",
                linkdescription: "",
                obj1Id: "",
                obj2Id: "",
                objType: "",
                obj1description: "",
                obj2description: "",
                hasfirst: false,
            };
        },
        components: {
            LinkPopUp,
            EventEdit,
            btn,
            LinkComponentPopEV,
            MergePopUpev,
        },
        methods: {
            async requestlinkdownload(id) {
                await RequestLink(id);
            },
            clearControls() {
                this.pagingInfo.search = "";
            },
            fetchData() {
                if (this.pagingInfo.mydata == "0") this.mydata = false;
                else this.mydata = true;

                instance
                    .get(RecordURL + "getevent", {
                        headers: authHeader(),
                        params: this.pagingInfo,
                    })
                    .then((response) => {
                        this.events = response.data.data;
                        this.totalitems = response.data.count;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                        this.mydata = false;
                        this.events = [];
                        this.totalitems = 0;
                    });
            },
            searchData() {
                this.pagingInfo.page = 1;
                this.fetchData();
            },
            More: function (data) {
                var additional =
                    (data.title ? data.title : "") + " " + (data.type ? data.type : "");
                additional = additional.replace(/\//g, "-");

                this.linkid = data.id;
                this.linkdescription = additional;
                this.$bvModal.show("linkpopupev");
            },
            sort: function (sortBy) {
                if (sortBy === this.pagingInfo.sortBy) {
                    this.pagingInfo.reverse = !this.pagingInfo.reverse;
                } else {
                    this.pagingInfo.sortBy = sortBy;
                    this.pagingInfo.reverse = false;
                }
                this.pagingInfo.page = 1;
                this.fetchData();
            },
            setLink: function (id) {
                setObject2Link(id, "EV");
                this.$bvModal.show("LinkPopupEV");
            },
            editEvent: function (id) {
                this.eventId = id;
                //modal
                this.$bvModal.show("EditPopUPEV");
            },
            doneEdit() {
                this.$bvModal.hide("EditPopUPEV");
            },
            startLink: function (doc) {
                this.$bvModal
                    .msgBoxConfirm("Are you sure you want to enable link mode?.", {
                        title: "Enable Link Mode?",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "success",
                        okTitle: "Yes",
                        cancelTitle: "No",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then((value) => {
                        if (value) {
                            var additional = "Event: " + (doc.title === null ? " " : doc.title);
                            this.$store.commit("enablelinkMode", {
                                id: doc.id,
                                type: "EV",
                                description: additional,
                            });
                        }
                    });
            },
            deleteEvent: function (id, index) {
                this.$bvModal
                    .msgBoxConfirm("Are you sure you want to delete?.", {
                        title: "Delete?",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "danger",
                        okTitle: "Yes",
                        cancelTitle: "No",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then((value) => {
                        if (value) {
                            instance
                                .get(RecordURL + "deleteEv?eventID=" + id, {
                                    headers: authHeader(),
                                })
                                .then((response) => {
                                    if (response.data.error) {
                                        notifyHelper("error", response.data.message);
                                    } else {
                                        notifyHelper("success", response.data.message);
                                        this.events.splice(index, 1)
                                    }
                                })
                                .catch(function (error) {
                                    responseCheck(error.response.status);
            });
                        }
                    });
            },
            addtoMerge(data) {
                var additional =
                    (data.type ? data.type : "") +
                    " " +
                    (data.title ? data.title : "");
                additional = additional.replace(/\//g, "-");
                if (this.hasfirst) {
                    if (this.obj1Id == data.id) {
                        notifyHelper("info", "Cannot merge the same event");
                    }
                    else {
                        this.obj2description = additional;
                        this.obj2Id = data.id;
                        this.objType = "EV"
                        //open the popup
                        this.$bvModal.show("mergerecordev");
                    }

                } else {
                    this.obj1description = additional;
                    this.obj1Id = data.id;
                    this.hasfirst = true;
                    notifyHelper(
                        "success",
                        "Add to merging of record, please choose another record to merge"
                    );
                }
            },
            cancel() {
                this.$bvModal.hide("mergerecordev");
                this.hasfirst = false;
                this.obj1Id = "";
                this.obj2Id = "";
                this.obj1description = "";
                this.obj2description = "";
            },
            done() {
                this.$bvModal.hide("mergerecordev");
                this.hasfirst = false;
                this.obj1Id = "";
                this.obj2Id = "";
                this.obj1description = "";
                this.obj2description = "";
                this.fetchData();
            }

        },
    };
</script>